import PasswordResetConfirmation from '../../pages/PasswordResetConfirmation'
import { usePasswordResetConfirmation } from '../../hooks/usePasswordResetConfirmation'

function PasswordResetConfirmationWrapper(props) {
  const { errorCode, processed, disabledForm, submit } =
    usePasswordResetConfirmation()

  return (
    <PasswordResetConfirmation
      siteKey={props.siteKey || ''}
      errorCode={errorCode}
      processed={processed}
      disabledForm={disabledForm}
      onSubmit={submit}
      onExecuteRecaptcha={() => {}}
    />
  )
}

export default PasswordResetConfirmationWrapper
